import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { Container, Button, Form } from 'reactstrap';
import { connect } from 'react-redux';
import Logger from 'util/Logger';
import { Band } from 'components/layout';
import ContactDetailsSection from './ContactDetailsSection';
import { preventEnterSubmit } from 'actions/formActions';

const propTypes = {
  handleSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  areas: PropTypes.array,
};

// Define onSubmitFail outside the component
const onSubmitFail = (errors) => {
  Logger.error(
    'We were unable to save the changes, please review the fields in red and try again.',
    errors,
    'Contact not saved'
  );
};

const ContactForm = (props) => {
  const { areas, handleSubmit, isSubmitting } = props;

  return (
    <Form onSubmit={handleSubmit} onKeyPress={preventEnterSubmit}>
      <Band tint>
        <ContactDetailsSection areas={areas} />
      </Band>
      <Container>
        <Button color="primary" className="btn-save" disabled={isSubmitting}>
          Save
        </Button>
      </Container>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  areas: state.referenceData.areas
});

ContactForm.propTypes = propTypes;

const WrappedContactForm = reduxForm({
  form: 'contactForm', // Corrected typo in form name
  enableReinitialize: true,
  onSubmitFail // Pass the standalone function
})(ContactForm);

export default connect(mapStateToProps)(WrappedContactForm);
